exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dev-priorities-ideas .cards-edit-box[data-v-7b3fb84b]{width:100%}.w50[data-v-7b3fb84b]{width:calc(50% - 10px)}@media (max-width:575px){.w50[data-v-7b3fb84b]{width:100%}}", ""]);

// exports
